import find from 'lodash/find';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { Layout } from '@abyss/web/ui/Layout';
import { Link } from '@abyss/web/ui/Link';
import React  from 'react';
import { useLagoon } from '../../hooks/useLagoon';
import { useTranslation } from 'react-i18next';

import { shouldUseGehaV2Styling } from '../../utils/gehaThemeUtils';
import { Constants } from '../Constants';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { ConstantsLagoon } from '../ConstantsLagoon';
import {
  StyledDisclaimerText,
  disclaimerLinkStyles,
} from './DisclaimersContainer.styled';

export const CaliforniaCommercialDisclaimer = ({
}) => {
  const { t } = useTranslation();
  const lagoonData = useLagoon(Constants.LAGOON_TABLE.UI_MESSAGING)();
  const californiaDirectoryDisclaimer = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.ENABLE_CALIFORNIA_DIRECTORY_DISCLAIMER,
  });
  const [enableCaliforniaDirectoryDisclaimer] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_CALIFORNIA_DIRECTORY_DISCLAIMER,
  ]);

  const isGEHAV2 = shouldUseGehaV2Styling();

  if (enableCaliforniaDirectoryDisclaimer) {
    return (
      <Layout.Stack alignItems="left" space="0">
        <StyledDisclaimerText
          cssProps={{ isGEHAV2 }}
          data-testid="california-commercial-disclaimer"
        >
           {`${californiaDirectoryDisclaimer?.title} `}
          <Link
            css={disclaimerLinkStyles}
            data-auto-testid="california-commercial-link-text"
            data-testid="california-commercial-link-text"
            hideIcon
            href={californiaDirectoryDisclaimer?.url}
          >
            {t(`${californiaDirectoryDisclaimer?.message} `)}
            <IconMaterial icon="chevron_right" size="$xs" />
          </Link>
        </StyledDisclaimerText>
        <br/>
      </Layout.Stack>
    );
  }

  return '';
};
